<!--
  - Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <page>
    <template v-slot:content>
      <div class="page">
        <section class="page-section">
          <div class="section-heading">
            <h1>Notifikace a restrikce</h1>
          </div>
          <div class="page-section-content">
            <div v-if="notifications" class="is-flex notifications-list">
              <router-link
                :key="`item_${notification.id}`"
                v-for="notification in notifications"
                :to="{
                  name: 'notification',
                  params: { idOrName: notification.slug }
                }"
              >
                <div class="card item">
                  <div class="card-content">
                    <div class="media">
                      <div class="media-content">
                        <p class="title is-4 crimson">
                          {{ notification.title }}
                        </p>
                        <p class="subtitle is-6">
                          <router-link
                            :to="{
                              name: 'articles',
                              query: { author: notification.author }
                            }"
                          >
                            {{ notification.author }}
                          </router-link>
                          published {{ timeAgo(notification.publishedAt) }}
                        </p>
                      </div>
                    </div>
                    <div class="content is-flex">
                      <div style="flex-grow: 1;">
                        <div
                          style="font-size: 1.5rem;line-height: 1.5rem;"
                          class="crimson"
                        >
                          {{ notification.excerpt }}
                        </div>
                      </div>
                      <div class="item-right-actions">
                        <button class="button">Read more...</button>
                      </div>
                    </div>
                  </div>
                  <footer class="card-footer item-footer">
                    <a href="#" class="card-footer-item">Read more</a>
                  </footer>
                </div>
              </router-link>
            </div>
            <br />
            <div class="show-more">
              <button class="button is-large">Show older...</button>
            </div>
          </div>
        </section>
      </div>
    </template>
  </page>
</template>

<script>
import Page from "./../common/page";
import { mapGetters } from "vuex";
import { format } from "timeago.js";

export default {
  components: {
    Page
  },
  computed: {
    ...mapGetters({ notifications: "notifications/notifications" })
  },
  metaInfo: {
    title: "Notifications/restrictions$"
  },
  methods: {
    timeAgo(date) {
      return format(date);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./../../styles/index";
@import "./page-scoped";

.show-more {
  display: flex;
  margin: 0 0 3rem 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.notifications-list {
  flex-direction: column;

  .item {
    margin-bottom: 1rem;

    .item-right-actions {
      display: flex;
      align-items: flex-end;

      @include mobile {
        display: none;
      }
    }

    .time {
      margin-top: 0.5rem;
      font-style: italic;
    }

    .item-footer {
      display: none;

      @include mobile {
        display: block;
      }
    }
  }
}
</style>
